'use client'

import React from 'react'

type Props = {
    radius: number
}

const WIDTH = 340
const HEIGHT = 220

export default function CircleChart({ radius }: Props) {
    const r = 80
    const cx = WIDTH / 2
    const cy = HEIGHT / 2

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <circle cx={cx} cy={cy} r={r} fill="#2563eb" opacity={0.15} stroke="#2563eb" strokeWidth={2} />
            <line x1={cx} y1={cy} x2={cx + r} y2={cy} stroke="#2563eb" strokeWidth={1.5} />
            <circle cx={cx} cy={cy} r={2.5} fill="#2563eb" />
            <text x={cx + r / 2} y={cy - 8} fontSize={12} textAnchor="middle" fill="#374151">r = {radius.toFixed(2)}</text>
        </svg>
    )
}
